import type { LumpsumRebalanceCategory, LumpsumRebalanceNoActionFund } from '../../../../api/rebalance.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { RebalanceNoActionFundCard } from '../cards/RebalanceNoActionFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type RebalanceNoActionBucketAccordionProps = {
  category: LumpsumRebalanceCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function RebalanceNoActionBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: RebalanceNoActionBucketAccordionProps) {
  const noActionFunds = getCategoryBucketItems<LumpsumRebalanceNoActionFund>(category?.noActionFunds)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.REBALANCE,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.noActionFunds
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.noActionFunds]}
      count={noActionFunds.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumRebalance,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.noActionFunds]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {noActionFunds.map((fund, fundIndex) => (
        <RebalanceNoActionFundCard
          key={`${fund?.isin ?? 'fund'}-${fundIndex}`}
          fund={fund}
          showBottomDivider={fundIndex < noActionFunds.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
